import { CheckoutSession } from '@nemuru-eng/js-api-client';

import { sortByDate } from '@/utils/sortByDate';

export class CheckoutSessionHpp {
  constructor(private value: CheckoutSession) {}

  public get distributions() {
    return 'hpp' in this.value && this.value.hpp?.distributions ? this.value.hpp?.distributions : [];
  }

  public get hasBeenDistributed() {
    return this.distributions.length > 0;
  }

  public get sortedDistributionsBySentAt() {
    return this.distributions.sort((a, b) => sortByDate(a.sentAt, b.sentAt, 'desc'));
  }

  public get hasPaymentIntents() {
    return this.value.paymentIntents.length > 0;
  }

  public get sortedPaymentIntentsByUpdatedAt() {
    return this.value.paymentIntents.sort((a, b) => sortByDate(a.updatedAt, b.updatedAt));
  }

  public get selectedPaymentMethodType() {
    return this.value.selectedPaymentMethodType;
  }

  public get selectedPaymentMethodId() {
    return this.value.paymentIntents.find(
      (paymentIntent) => paymentIntent.paymentMethodType === this.selectedPaymentMethodType,
    )?.paymentMethodId;
  }
}
